
import { BlockModule } from "../../types/block/common/block-module";
import { VC_TYPE, BUNDLE_TYPE, VI_TYPE, BundleItem } from '../../utils/store';

export const existAuthBundles = (
  bundles,
  landingType,
) =>
  bundles.some((bundle) =>
    new BundleItem(bundle, landingType).filterAuthRequired()
  );

export const isActiveStoreBlock = (block) =>
  block.module === BlockModule.STORE &&
  block.components.some(
    (component) => component.type === 'storeSection' && component.enable
  );

export const checkStoreAuthRequired = (
  blocks,
  bundles,
  landingType,
) => {
  const storeBlocks = blocks.filter(isActiveStoreBlock);
  if (!storeBlocks.length) {
    return false;
  }
  return storeBlocks.some((block) =>
    block.components.some(
      (component) =>
        component.storeItemsType === VI_TYPE ||
        component.storeItemsType === VC_TYPE ||
        (component.storeItemsType === BUNDLE_TYPE &&
          existAuthBundles(bundles, landingType))
    )
  );
};
